import React from "react";

import styles from "./style.module.css";

export default class MonitorWarning extends React.Component {
  state = {
    showWarning: this.props.show !== undefined ? this.props.show : false
  };
  render() {
    const { show, onChange } = this.props;

    const { showWarning } = this.state;

    const retShow = show !== undefined ? show : showWarning;

    if (!retShow) {
      return <React.Fragment />;
    }

    return (
      <div className={styles.monitorWarningWrapper}>
        <div className={styles.monitorWarning}>
          <a
            className={styles.monitorWarningClose}
            onClick={onChange ? onChange : () => this.setState({ showWarning: false })}
          >
            {"✕"}
          </a>
          <div className={styles.monitorWarningText}>
            <strong style={{ display: "block" }}>{"No monitoring data detected."}</strong>
            <span>{"Showing sample monitoring view."}</span>
          </div>
        </div>
      </div>
    );
  }
}
